
let count;

if (window.matchMedia('(max-width: 767px)').matches) {
  let count = 2;
} else if (window.matchMedia('(min-width:768px)').matches) {
  let count = 3;
}

const mySwiper3 = new Swiper('.swiper-container2', {
  loop: true, // ループ有効
  slidesPerView: 3, // 一度に表示する枚数
  speed: 2000,
  autoplay: { // 自動再生させる
    delay: 1000, // 次のスライドに切り替わるまでの時間（ミリ秒）
    disableOnInteraction: true, // ユーザーが操作しても自動再生を止めない
    waitForTransition: true, // アニメーションの間も自動再生を止めない（最初のスライドの表示時間を揃えたいときに）
  },
});


////////////////// テキスト置換
const profile_text = document.querySelectorAll('.profile_text');
profile_text.forEach(element => {
  let text = element.innerText.replace('01_','')
  element.textContent = text
});
const roll = document.querySelectorAll('.roll_name');
roll.forEach(element => {
  let text2 = element.innerText.replace('02_','')
  element.textContent = text2
});





////////////////// 慣性スクロール
if (window.matchMedia('(max-width: 767px)').matches) {
  //スマホ処理
  console.log("スマホだよ")
} else if (window.matchMedia('(min-width:768px)').matches) {
  const lenis = new Lenis({
    duration: 1.2, // アニメーションの継続時間
    direction: 'vertical', // 方向
    gestureDirection: 'vertical',
    smooth: true, // スムーススクロールの有効・無効を設定
    smoothTouch: false, // タッチスクロール時のスムーススクロールの有効・無効を設定。(タッチデバイス本来の滑らかさを模倣することは不可能であるため、デフォルト無効)
    touchMultiplier: 2,
  })
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf)
}


const p_list1 = document.querySelectorAll(".article_section_inner_01 p")
const p_list2 = document.querySelectorAll(".article_section_inner_02 p")
const p_list3 = document.querySelectorAll(".article_section_inner_03 p")
p_list1.forEach(function(element, i) {
  gsap.fromTo(
    p_list1[i], // アニメーションさせる要素
    {opacity: 0,y: 30,},
    {
      opacity: 1,y: 0,duration: 0.3,
      scrollTrigger: {
        trigger: p_list1[i],
        toggleActions: "play none none none", 
        start: "top-=200 center", 
        // markers: true,
      },
    }
  );
});
p_list2.forEach(function(element, i) {
  gsap.fromTo(
    p_list2[i], // アニメーションさせる要素
    {opacity: 0,y: 30,},
    {
      opacity: 1,y: 0,duration: 0.3,
      scrollTrigger: {
        trigger: p_list2[i],
        toggleActions: "play none none none", 
        start: "top-=200 center", 
        // markers: true,
      },
    }
  );
});
p_list3.forEach(function(element, i) {
  gsap.fromTo(
    p_list3[i], // アニメーションさせる要素
    {opacity: 0,y: 30,},
    {
      opacity: 1,y: 0,duration: 0.3,
      scrollTrigger: {
        trigger: p_list3[i],
        toggleActions: "play none none none", 
        start: "top-=200 center", 
        // markers: true,
      },
    }
  );
});

////////// gsap
ScrollTrigger.matchMedia({
  ////////////////////////////////////////////////////////////// desktop
  "(min-width: 800px)": function () {
    ////////////////////////////////////////////////////////// ステッカー
    gsap.fromTo(
      ".article_stick_image1", // アニメーションさせる要素
      {
        autoAlpha: 0, 
        opacity: 0,
        scale: 0.9,
      },
      {
        autoAlpha: 1, 
        opacity: 1,
        scale: 1,
        duration: 0.3,
        scrollTrigger: {
          trigger: ".article_section_01",
          toggleActions: "play reverse play reverse", 
          start: "top+=300 center", 
          end: 'bottom-=600 center',
          // markers: true,
        },
      }
    );
    gsap.fromTo(
      ".article_stick_image2", // アニメーションさせる要素
      {
        autoAlpha: 0, // アニメーション開始前は透明
        opacity: 0,
        scale: 0.9,
      },
      {
        autoAlpha: 1, // アニメーション後に出現(透過率0)
        opacity: 1,
        scale: 1,
        duration: 0.3,
        scrollTrigger: {
          trigger: ".article_section_02",
          toggleActions: "play reverse play reverse", // 上スクロールで戻る
          start: "top+=300 center", // アニメーションの開始位置
          end: 'bottom-=600 center', // 要素のbottomを下方向に200px 
          // markers: true,
        },
      }
    );
    gsap.fromTo(
      ".article_stick_image3", // アニメーションさせる要素
      {
        // autoAlpha: 0, // アニメーション開始前は透明
        opacity: 0,
        scale: 0.9,
      },
      {
        // autoAlpha: 1, // アニメーション後に出現(透過率0)
        opacity: 1,
        scale: 1,
        duration: 0.3,
        scrollTrigger: {
          trigger: ".article_section_03", // アニメーションが始まるトリガーとなる要素
          toggleActions: "play reverse play reverse", // 上スクロールで戻る
          start: "top+=300 center", // アニメーションの開始位置
          end: 'bottom-=600 center', // 要素のbottomを下方向に200px 
          // markers: true,
        },
      }
    );
    gsap.fromTo(
      ".article_stick_image4", // アニメーションさせる要素
      {
        // autoAlpha: 0, // アニメーション開始前は透明
        opacity: 0,
        scale: 0.9,
      },
      {
        // autoAlpha: 1, // アニメーション後に出現(透過率0)
        opacity: 1,
        scale: 1,
        duration: 0.3,
        scrollTrigger: {
          trigger: ".article_section_04", // アニメーションが始まるトリガーとなる要素
          toggleActions: "play reverse play reverse", // 上スクロールで戻る
          start: "top+=300 center", // アニメーションの開始位置
          end: 'bottom-=600 center', // 要素のbottomを下方向に200px 
          // markers: true,
        },
      }
    );
    gsap.fromTo(
      ".article_stick_image5", // アニメーションさせる要素
      {
        // autoAlpha: 0, // アニメーション開始前は透明
        opacity: 0,
        scale: 0.9,
      },
      {
        // autoAlpha: 1, // アニメーション後に出現(透過率0)
        opacity: 1,
        scale: 1,
        duration: 0.3,
        scrollTrigger: {
          trigger: ".article_section_05", // アニメーションが始まるトリガーとなる要素
          toggleActions: "play reverse play reverse", // 上スクロールで戻る
          start: "top+=300 center", // アニメーションの開始位置
          end: 'bottom-=600 center', // 要素のbottomを下方向に200px 
          // markers: true,
        },
      }
    );
    
    //////////////////////////////////////////////////////////// 背景色
    gsap.to(
      ".footwork_wrapper", // アニメーションさせる要素
      {
        // backgroundColor:"#ED7137",
        duration: 0.2,
        scrollTrigger: {
          trigger: ".article_section_01", // アニメーションが始まるトリガーとなる要素
          // toggleActions: "play none none reverse", // 上スクロールで戻る
          toggleClass: { targets: ".footwork_section", className: "color1", },
          start: "top center", // アニメーションの開始位置
          end: 'bottom center', // 要素のbottomを下方向に200px 
        },
      }
    );
    gsap.to(
      ".footwork_wrapper", // アニメーションさせる要素
      {
        // backgroundColor:"#ED7137",
        duration: 0.2,
        scrollTrigger: {
          trigger: ".article_section_02", // アニメーションが始まるトリガーとなる要素
          // toggleActions: "play none none reverse", // 上スクロールで戻る
          toggleClass: { targets: ".footwork_section", className: "color2", },
          start: "top center", // アニメーションの開始位置
          end: 'bottom center', // 要素のbottomを下方向に200px 
        },
      }
    );
    gsap.to(
      ".footwork_wrapper", // アニメーションさせる要素
      {
        // backgroundColor:"#F3EFE8",
        duration: 0.2,
        scrollTrigger: {
          trigger: ".article_section_03", // アニメーションが始まるトリガーとなる要素
          // toggleActions: "play none none pause", // 上スクロールで戻る
          toggleClass: { targets: ".footwork_section", className: "color3", },
          start: "top center", // アニメーションの開始位置
          end: 'bottom center', // 要素のbottomを下方向に200px 
        },
      }
    );
    gsap.to(
      ".footwork_wrapper", // アニメーションさせる要素
      {
        // backgroundColor:"#F3EFE8",
        duration: 0.2,
        scrollTrigger: {
          trigger: ".article_section_04", // アニメーションが始まるトリガーとなる要素
          // toggleActions: "play none none pause", // 上スクロールで戻る
          toggleClass: { targets: ".footwork_section", className: "color4", },
          start: "top center", // アニメーションの開始位置
          end: 'bottom center', // 要素のbottomを下方向に200px 
        },
      }
    );
    gsap.to(
      ".footwork_wrapper", // アニメーションさせる要素
      {
        // backgroundColor:"#F3EFE8",
        duration: 0.2,
        scrollTrigger: {
          trigger: ".article_section_05", // アニメーションが始まるトリガーとなる要素
          // toggleActions: "play none none pause", // 上スクロールで戻る
          toggleClass: { targets: ".footwork_section", className: "color5", },
          start: "top center", // アニメーションの開始位置
          end: 'bottom center', // 要素のbottomを下方向に200px 
        },
      }
    );
  },
  
  //////////////////////////////////////////////////////////// スマホ
  "(max-width: 799px)": function () {
    //////////////////////////////////////////////////////////// 画像ステッカー
    gsap.fromTo(
      ".article_stick_image1", // アニメーションさせる要素
      {
        autoAlpha: 0, // アニメーション開始前は透明
        opacity: 0,
        scale: 0.9,
      },
      {
        autoAlpha: 1, // アニメーション後に出現(透過率0)
        opacity: 1,
        scale: 1,
        duration: 0.3,
        scrollTrigger: {
          trigger: ".article_stick_image1", // アニメーションが始まるトリガーとなる要素
          toggleActions: "play none reverse reverse", // 上スクロールで戻る
          start: "top center+=100", // アニメーションの開始位置
          end:  "bottom center-=100"
          // markers: true,
        },
      }
    );
    gsap.fromTo(
      ".article_stick_image2", // アニメーションさせる要素
      {
        autoAlpha: 0, // アニメーション開始前は透明
        opacity: 0,
        scale: 0.9,
      },
      {
        autoAlpha: 1, // アニメーション後に出現(透過率0)
        opacity: 1,
        scale: 1,
        duration: 0.3,
        scrollTrigger: {
          trigger: ".article_section_02",
          toggleActions: "play none reverse reverse", // 上スクロールで戻る
          start: "top+=150 center+=100", 
          end:  "bottom center-=100"
        },
      }
    );
    gsap.fromTo(
      ".article_stick_image3", // アニメーションさせる要素
      {
        autoAlpha: 0, // アニメーション開始前は透明
        opacity: 0,
        scale: 0.9,
      },
      {
        autoAlpha: 1, // アニメーション後に出現(透過率0)
        opacity: 1,
        scale: 1,
        duration: 0.3,
        scrollTrigger: {
          trigger: ".article_section_03", // アニメーションが始まるトリガーとなる要素
          toggleActions: "play none reverse reverse", // 上スクロールで戻る
          start: "top+=150 center+=100", 
          end:  "bottom center-=100"
        },
      }
    );
    gsap.fromTo(
      ".article_stick_image4", // アニメーションさせる要素
      {
        autoAlpha: 0, // アニメーション開始前は透明
        opacity: 0,
        scale: 0.9,
      },
      {
        autoAlpha: 1, // アニメーション後に出現(透過率0)
        opacity: 1,
        scale: 1,
        duration: 0.3,
        scrollTrigger: {
          trigger: ".article_section_04", // アニメーションが始まるトリガーとなる要素
          toggleActions: "play none reverse reverse", // 上スクロールで戻る
          start: "top+=150 center+=100", 
          end:  "bottom center-=100"
        },
      }
    );
    gsap.fromTo(
      ".article_stick_image5", // アニメーションさせる要素
      {
        autoAlpha: 0, // アニメーション開始前は透明
        opacity: 0,
        scale: 0.9,
      },
      {
        autoAlpha: 1, // アニメーション後に出現(透過率0)
        opacity: 1,
        scale: 1,
        duration: 0.3,
        scrollTrigger: {
          trigger: ".article_section_05", // アニメーションが始まるトリガーとなる要素
          toggleActions: "play none reverse reverse", // 上スクロールで戻る
          start: "top+=150 center+=100", 
          end:  "bottom center-=100"
        },
      }
    );
    

    //////////////////////////////////////////////////////////// 背景色
    gsap.to(
      ".footwork_wrapper", // アニメーションさせる要素
      {
        duration: 0.2,
        scrollTrigger: {
          trigger: ".article_section_01", // アニメーションが始まるトリガーとなる要素
          // toggleActions: "play none none reverse", // 上スクロールで戻る
          toggleClass: { targets: ".footwork_section", className: "color1", },
          start: "top+=350 center+=100", // アニメーションの開始位置
          // markers: true,
        },
      }
    );
    gsap.to(
      ".footwork_wrapper", // アニメーションさせる要素
      {
        duration: 0.2,
        scrollTrigger: {
          trigger: ".article_section_02", // アニメーションが始まるトリガーとなる要素
          // toggleActions: "play none none reverse", // 上スクロールで戻る
          toggleClass: { targets: ".footwork_section", className: "color2", },
          start: "top+=350 center+=100", // アニメーションの開始位置
        },
      }
    );
    gsap.to(
      ".footwork_wrapper", // アニメーションさせる要素
      {
        duration: 0.2,
        scrollTrigger: {
          trigger: ".article_section_03", // アニメーションが始まるトリガーとなる要素
          // toggleActions: "play none none reverse", // 上スクロールで戻る
          toggleClass: { targets: ".footwork_section", className: "color3", },
          start: "top+=350 center+=100", // アニメーションの開始位置
        },
      }
    );
  }
})